import { ICommandBase } from '@/commands/interface/iCommandBase';
import { PatternBaseLayer } from '@/model/document2/page/surface/design/layer/patternBaseLayer';
import { PolygonLayer } from '@/model/document2/page/surface/design/layer/polygonLayer';
import { ColorConstruct } from '@/utilityModels/colorConstruct';

// 図形のグラデーション色変更コマンド
export class ChangeGradationColorOfPatternCommand implements ICommandBase
{
    private layer! : PatternBaseLayer | PolygonLayer;
    private index! : number;
    private color! : ColorConstruct;
    private doneCallback! : () => void;

    private oldColor : ColorConstruct = new ColorConstruct();

    constructor(layer : PatternBaseLayer | PolygonLayer, index : number, color : ColorConstruct, doneCallback : () => void)
    {
        this.layer = layer;
        this.index = index;
        this.color = color;
        this.doneCallback = doneCallback;

        // 現在の色
        this.oldColor = layer.getGradation(index).color;
    }

    public do() : void
    {
        // グラデーション色変更
        this.layer.changeGradationColor(this.index, this.color);
        // 変更がわかるように選択を変更
        this.layer.selectedGradationPoint = this.index;

        this.doneCallback();
    }

    public undo() : void
    {
        // グラデーション色変更
        this.layer.changeGradationColor(this.index, this.oldColor);
        // 変更がわかるように選択を変更
        this.layer.selectedGradationPoint = this.index;

        this.doneCallback();
    }

    public redo() : void
    {
        // グラデーション色変更
        this.layer.changeGradationColor(this.index, this.color);
        // 変更がわかるように選択を変更
        this.layer.selectedGradationPoint = this.index;

        this.doneCallback();
    }
}